import { useClikArtCategoriesWarmup } from '@/api/hooks/use-clikart-categories-warmup'

/**
 * Headless checker: warms the backend's ClikArt categories cache once the first spread is up, so
 * the ClikArt panel opens instantly. Lives here (like the font checkers) rather than as a home
 * group hook so the load-bearing group-hook call order in `home.tsx` stays untouched.
 */
export function ClikArtCatalogWarmup({ isCheckpointLoaded }: { isCheckpointLoaded: boolean }) {
  useClikArtCategoriesWarmup(isCheckpointLoaded)

  return null
}
